// extracted by mini-css-extract-plugin
export default {"classList":"ClassList_classList__XNVkr","classItem":"ClassList_classItem__WdBIz"};